import type { QueryClient } from '@tanstack/react-query';
import { knowledgeQueryKeys } from './knowledgeQueryKeys';

export function invalidateKnowledgeDatabaseSummaries(
  queryClient: QueryClient,
  databaseId: string,
) {
  void queryClient.invalidateQueries({
    queryKey: knowledgeQueryKeys.database(databaseId),
  });
  void queryClient.invalidateQueries({
    queryKey: knowledgeQueryKeys.databases(),
  });
}
